<template>
  <PersonnelAssess/>
</template>
<script>
import PersonnelAssess from 'place/personnelverify/personnelAssess.vue'
export default {
    components:{
      PersonnelAssess
    }
}
</script>